import { useSuspenseQuery } from '@tanstack/react-query';

import { getBookValidationHistoryOptions } from '@/module/Author/Book/Validation/model/BookValidationModel';

import { Id } from '@feature/utils';
import { ValidationHistoryContent } from '@feature/validation/ValidationHistoryContent';

interface BookValidationHistoryProps {
  bookId: Id;
}

export function BookValidationHistory({ bookId }: BookValidationHistoryProps) {
  const { data: history } = useSuspenseQuery(getBookValidationHistoryOptions(bookId));

  return <ValidationHistoryContent history={history} />;
}
